import React, { useState, useRef, useEffect } from 'react'
import { data, useNavigate } from 'react-router-dom'
import { LogErrors } from './../../utilities/LogErrors'

//Funciones comunes
import { Confirms as BLConfirms } from './../../utilities/BL/Confirms'
import { ValidateSession } from './../../utilities/BL/Sessions'
import { useLanguage } from './../../utilities/LanguageContext'

//Componentes comunes
import { Header } from './../Header/Header'
import { Input } from './../Login/Fields/Input'
//import { Button } from './../Common/Button'
import { Loading } from './../Common/Loading'

import { CreditsText } from './../Common/Credits/CreditsText'


const Confirm = () => {
  const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
  const navigate = useNavigate()

  //Estados
  //const [formData, setFormData] = useState({ name: '', lastName: '', nickname: '', email: '', password: '' }) // Estado que maneja la info del formulario
  const [formData, setFormData] = useState({ name: '', lastName: '', nickname: '', email: '', password: '', confirmPassword: '' })
  const [errors, setErrors] = useState({}) // Estado que maneja los errores
  const [isSubmitted, setIsSubmitted] = useState(false) // Estado que controla si se ha enviado, o no, el formulario
  
  const [isLoading, setIsLoading] = useState(true)
  const [isButtonLoading, setIsButtonLoading] = useState(false)
  const [theme, setTheme] = useState(null)
  const [userStatus, setUserStatus] = useState(null)
  const [originalData,setOriginalData] = useState({ name: '', lastName: '', nickname: '', email: ''})

  const status = {
    FIRSTTIME: 1,
    ACTIVE: 2,
    INACTIVE: 3,
    RESETED: 4
  }

  // Referencias
  const refs = {
    name: useRef(null),
    lastName: useRef(null),
    nickname: useRef(null),
    email: useRef(null),
    password: useRef(null),
    confirmPassword: useRef(null)
  }

  
  //--- Funciones personalizadas ---//
  const SetDataToSend = async (userStatus) => {
    try {
      if (userStatus === status.FIRSTTIME) {
        const dataToSend = {
          name: formData.name,
          lastName: formData.lastName,
          nickname: formData.nickname,
          email: formData.email,
          password: formData.password
        }
        return dataToSend

      } else if (userStatus === status.RESETED) {
        const dataToSend = {
          name: originalData.name,
          lastName: originalData.lastName,
          nickname: originalData.nickname,
          email: originalData.email,
          password: formData.password
        }
        return dataToSend

      } else {
        return null
      }
    } catch (error) {
      return null
    }
  }

  const LoadPage = async (sessionInfo) => {
    try {
      setTheme(sessionInfo.user.userTheme)
      
      
      const tmpUserStatus = sessionInfo?.user?.userStatus
      if (!tmpUserStatus) {
        return
      }
      
      formData.name = sessionInfo.user.name
      formData.lastName = sessionInfo.user.lastName
      
      if (tmpUserStatus === status.RESETED) {  
        // Colocar la info del usuario en los campos correspondientes
        formData.nickname = sessionInfo.user.nickname
        formData.email = sessionInfo.user.email

        // Guardar info original
        originalData.name = sessionInfo.user.name
        originalData.lastName = sessionInfo.user.lastName
        originalData.nickname = sessionInfo.user.nickname
        originalData.email = sessionInfo.user.email
        setOriginalData(originalData)
      }
      
      setFormData(formData)

      switch (tmpUserStatus) {
        case status.FIRSTTIME:
          setUserStatus(status.FIRSTTIME)
          break

        case status.ACTIVE:
          setUserStatus(status.ACTIVE)
          break

        case status.INACTIVE:
          setUserStatus(status.INACTIVE)
          break

        case status.RESETED:
          setUserStatus(status.RESETED)
          break
      
        default:
          break
      }
    } catch (error) {
      await LogErrors('LoadPage - Confirm', error)
    } finally {
      setIsLoading(false)
    }
  }

  const Confirm = async (e) => {
    try {
      e.preventDefault()
      setIsButtonLoading(true)

      const session = await ValidateSession()
      
      if (session.success) {
        if (session.data.user.userStatus === status.ACTIVE) {
          navigate('/dashboard')
        } else {
          setIsSubmitted(true) // Marcar el formulario como enviado

          const dataToSend = await SetDataToSend(session.data.user.userStatus)
          
          if (dataToSend) {
            if (formData.password !== formData.confirmPassword) {
              setErrors(prev => ({
                ...prev,
                confirmPassword: 'Las contraseñas no coinciden'
              }))

              // Enfoca el campo de confirmación
              refs.confirmPassword.current?.focus()
              setIsButtonLoading(false)

              return // no continúes con la llamada a la API
            }

            const response = await BLConfirms(session.data, dataToSend)
            
            if (response.success) {
              navigate('/dashboard')
            } else {
              // Muestra los errores si los hay
              setErrors(response.errors)
  
              // Hacer focus en el campo correspondiente
              for (const key in response.errors) {
                if (response.errors[key]) {
                  refs[key].current.focus()
                  break
                }
              }
            }
          } else {
            console.log("No ha sido posible guardar tus datos. Inténtalo nuevamente o inténtalo más tarde.")
          }
        }
      } else {
        navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
      }
    } catch (error) {
      await LogErrors('Confirm - Confirm', error)
    } finally {
      setIsButtonLoading(false)
    }
  }
  //--- Funciones personalizadas ---//

  //--- Eventos de la página web ---//
  useEffect(() => {
    async function Validate() {
      const tmpSession = await ValidateSession()
      
      if (tmpSession.success) {
        if (tmpSession.data.user.userStatus === status.ACTIVE) {
          navigate('/dashboard')
        } else {
          await LoadPage(tmpSession.data)
        }
      } else {
          navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
      }
    }
    Validate()
  }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar
  //--- Eventos de la página web ---//

  //--- Eventos de formulario ---//
  /**
   * Función que se ejecuta cuando se realiza un cambio en los campos del formulario.
   * @param {Event} e
   */
  const InputChange = async (e) => {
    try {
      const { id, value } = e.target

      setFormData({
        ...formData,
        [id]: value,
      })

      // Limpia el error del campo editado (quality of life)
      if (errors?.[id]) {
        setErrors(prev => ({ ...prev, [id]: null }))
      }
    } catch (error) {
      await LogErrors('InputChange - Confirm', error)
    }
  }

  /**
   * Función que se ejecuta cuando se presiona la tecla Enter o se presiona el botón del formulario
   * @param {Event} e
   */
  const FormSubmit = async (e) => {
    try {
      Confirm(e)
    } catch (error) {
      await LogErrors('FormSubmit - Confirm', error)
    }
  }
  //--- Eventos de formulario ---//

  
  return (
    <>
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <Header theme={theme} />

            <main className="container Container-FullHeight"> {/* Container-FlexContent */}
              {(userStatus === status.FIRSTTIME || userStatus === status.RESETED) ? (
                <div className="Confirm">
                  {userStatus === status.FIRSTTIME ? (
                    <h1 className="Confirm-Title">Confirma tus datos</h1>
                  ) : userStatus === status.RESETED && (
                    <h1 className="Confirm-Title">Se ha reestablecido tu contraseña. Establece una nueva.</h1>
                  )}

                  <form className="Confirm-Form" onSubmit={FormSubmit}>
                    <Input
                      type="text"
                      id="name"
                      value={formData.name}
                      onChange={InputChange}
                      placeholder={translate('labels.confirm.name')}
                      error={isSubmitted ? errors.name : null}
                      isSubmitted={isSubmitted}
                      ref={refs.name}
                      disabled={userStatus === status.FIRSTTIME ? false : true}
                    />

                    <Input
                      type="text"
                      id="lastName"
                      value={formData.lastName}
                      onChange={InputChange}
                      placeholder={translate('labels.confirm.lastName')}
                      error={isSubmitted ? errors.lastName : null}
                      isSubmitted={isSubmitted}
                      ref={refs.lastName}
                      disabled={userStatus === status.FIRSTTIME ? false : true}
                    />

                    <Input
                      type="text"
                      id="nickname"
                      value={formData.nickname}
                      onChange={InputChange}
                      placeholder={translate('labels.confirm.nickname')}
                      error={isSubmitted ? errors.nickname : null}
                      isSubmitted={isSubmitted}
                      ref={refs.nickname}
                      disabled={userStatus === status.FIRSTTIME ? false : true}
                    />
                    <label className='Confirm__Text--Small Confirm__Text--Cursive'>Máximo 25 caracteres</label>

                    <Input
                      type="email"
                      id="email"
                      value={formData.email}
                      onChange={InputChange}
                      placeholder={translate('labels.confirm.email')}
                      error={isSubmitted ? errors.email : null}
                      isSubmitted={isSubmitted}
                      ref={refs.email}
                      disabled={userStatus === status.FIRSTTIME ? false : true}
                    />

                    <Input
                      type="password"
                      id="password"
                      value={formData.password}
                      onChange={InputChange}
                      placeholder={translate('labels.confirm.password')}
                      error={isSubmitted ? errors.password : null}
                      isSubmitted={isSubmitted}
                      ref={refs.password}
                    />
                    <label className='Confirm__Text--Small Confirm__Text--Cursive'>Mínimo 8 caracteres. Incluir 1 mayúscula, 1 minúscula, 1 número y 1 caracter especial</label>

                    <Input
                      type="password"
                      id="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={InputChange}
                      placeholder={translate('labels.confirm.repeatPassword') || 'Repite tu contraseña'}
                      error={isSubmitted ? errors.confirmPassword : null}
                      isSubmitted={isSubmitted}
                      ref={refs.confirmPassword}
                    />
                    
                    {isButtonLoading ? (
                      <button type='button' className='Confirm-Form-Button Confirm-Form-Button-Disabled'>{translate('labels.confirm.loadingSubmit')}</button>
                    ) : (
                      <button type='submit' className='Confirm-Form-Button'>{translate('labels.confirm.submit')}</button>
                    )}

                    {errors.general && <p className="Confirm-Form-Error-Message">{errors.general}</p>}
                  </form>
                </div>
              ) : (
                userStatus === status.ACTIVE ? (
                  <p className='text-center'>No ha sido posible mostrar la página. Actualiza la página o intenta actualizarla más tarde.</p>
                ) : userStatus === status.INACTIVE && (
                  <p className='text-center'>Actualmente tu cuenta está marcada como inactiva. Consulta con tu instructor.</p>
                )
              )}
            </main>

            <footer className='pb-2'>
              <p className='text-center'><CreditsText /></p>
              <div className='d-flex flex-wrap justify-content-center'>
                  <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px' }} onClick={() => navigate('/legals/privacy')}>Aviso de privacidad</p>
                  <p style={{textAlign: 'center', cursor: 'pointer', textDecoration: 'underline', fontSize: '12px', marginBottom: '12px', marginLeft: '16px' }} onClick={() => navigate('/contact')}>Contacto</p>
              </div>
            </footer>
          </>
      )}
    </>
  )
}

export { Confirm };